import { TESTING_INSPECTOR_SEARCH_START_LOADING, TESTING_INSPECTOR_SEARCH_END_LOADING, TESTING_INSPECTOR_SEARCH_LOADED, SET_TESTING_INSPECTOR_FILTER } from "../constants/IneTestingInspectorConstants";
import { TESTING_INSPECTOR_START_LOADING, TESTING_INSPECTOR_END_LOADING, TESTING_INSPECTOR_LOADED } from "../constants/IneTestingInspectorConstants";

import { getApiData, postApiJsonData } from "../utils/index";
import * as commonActions from "./CommonActions";

export function loadTestingInspectorSearch(filters, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: TESTING_INSPECTOR_SEARCH_START_LOADING });

        try {

            var data = await postApiJsonData("TestingInspector/GetPaged", filters, null);
            
            if(data.success) {
                await dispatch({
                    type: TESTING_INSPECTOR_SEARCH_LOADED,
                    payload: {
                        dataList: data.responseEntities[0].dataList
                        , searchList: data.responseEntities[0].userSearches
                        , totalCount: data.responseEntities[0].totalCount
                    }
                });
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: TESTING_INSPECTOR_SEARCH_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: TESTING_INSPECTOR_SEARCH_END_LOADING });
        }
    };
}

export function setTestingInspectorFilter(filter) {
    return async (dispatch) => {
        await dispatch({
            type: SET_TESTING_INSPECTOR_FILTER,
            payload: filter
        });
    };
}

export function loadTestingInspector(id, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: TESTING_INSPECTOR_START_LOADING });

        try {

            var data = await getApiData("TestingInspector/GetTestingInspectorFBO", { id });
            
            if(data.success) {
                await dispatch({
                    type: TESTING_INSPECTOR_LOADED,
                    payload: data.responseEntities[0]
                });
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: TESTING_INSPECTOR_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: TESTING_INSPECTOR_END_LOADING });
        }
    };
}

export function saveTestingInspector(fbo, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: TESTING_INSPECTOR_START_LOADING });

        try {

            var data = await postApiJsonData("TestingInspector/SaveTestingInspectorFBO", null, fbo);
            
            if(data.success) {
                await dispatch({
                    type: TESTING_INSPECTOR_LOADED,
                    payload: data.responseEntities[0]
                });
                
                dispatch(commonActions.setSuccessMessage("Inspector Saved Successfully!"));
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: TESTING_INSPECTOR_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: TESTING_INSPECTOR_END_LOADING });
        }
    };
}